/* eslint-disable */

import request from '@/utils/request'

export function getListBusinessAreaApi(query) {
  return request({
    url: '/config-service/v1/business-district/list',
    method: 'get',
    params: query
  })
}
export function getBusinessAreaByIdApi(id) {
  return request({
    url: `/config-service/v1/business-district/${id}`,
    method: 'get'
  })
}
export function getDefaultTransactionApi() {
  return request({
    url: '/config-service/v1/special-service/special-service/transaction',
    method: 'get',
    params: {
      transaction_group: 1
    }
  })
}
export function getCancelTransactionApi() {
  return request({
    url: '/config-service/v1/special-service/special-service/transaction',
    method: 'get',
    params: {
      transaction_group: 2
    }
  })
}

export function getWarehouseApi() {
  return request({
    url: '/config-service/v1/warehouse/warehouse',
    method: 'get',
    params: {
      isParent: false
    }
  })
}

export function addBusinessAreaApi(query) {
  return request({
    url: '/config-service/v1/business-district/insert',
    method: 'post',
    data: query
  })
}

export function updateBusinessAreaApi(query) {
  return request({
    url: `/config-service/v1/business-district/update/${query.id}`,
    method: 'put',
    data: query
  })
}
export function deleteBusinessAreaApi(query) {
  return request({
    url: '/config-service/v1/business-district/delete-ids',
    method: 'delete',
    data: query
  })
}
